import React from 'react';
import { Input } from '../../atoms/input';
import { HeaderContainer, HeaderRow, PageLine, PageTitle } from './styles';

const PageHeader = ({ title, headerButtons, isInput = false, inputProps = {} }) => {
  return (
    <HeaderContainer>
      <HeaderRow>
        {isInput ? (
          <Input
            value={inputProps.value || ''}
            placeholder={inputProps.placeholder || ''}
            onChange={inputProps.onChange}
            style={{
              fontFamily: 'Montserrat SemiBold',
              fontSize: 28,
              letterSpacing: '2px',
              height: 'auto',
              maxWidth: '50%',
              padding: 0,
              marginBottom: 24,
              border: 'none',
              boxShadow: 'none',
              background: 'transparent',
              color: '#102E4C',
              ...inputProps.style
            }}
          />
        ) : (
          <PageTitle>{title}</PageTitle>
        )}
        {headerButtons && (
          <div style={{ width: 'auto', marginLeft: 'auto', display: 'flex' }}>
            {headerButtons}
          </div>
        )}
      </HeaderRow>
      <PageLine />
    </HeaderContainer>
  );
};

export { PageHeader };
